let result;

export const getCBSWidget = () => {
  if (result) return Promise.resolve(result);
  return import('./cbs-widget').then((module) => {
    result = module;
    return module;
  });
};